import { useState, useEffect, useRef } from 'react';

import { dataSlide, dataSlideResult } from 'data/generalOutline';
import './style.scss';
import SidebarScroll, { Element } from '../../SidebarScroll';
import ComplexSection from './ComplexSection';
import PremiumSection from './PremiumSection';
import CalenderSection from './CalenderSection';
import NewsSection from './NewsSection';

import { GetStyledCompImg } from 'common-modules/general/Modules/functions';
import { RoutesString } from 'common-modules/general/Config/routesString';
import MainModel from 'common-modules/general/Common/Logic/Main/MainSalesCommon';
import { observer, useLocalObservable } from 'mobx-react';
import { toJS } from 'mobx';
import PageMoveText from 'common-modules/general/Common/Components/Button/PageMoveText';
import ImgPopup from '../../ImgPopup';
import ImgZoomModel from 'common-modules/general/Model/ImgZoomModel';

interface Props {
  mainModel: MainModel;
}

const GeneralOutline = observer(({ mainModel }: Props) => {
  // const isScheduledForSale = toJS(mainModel.mainData.data?.cdPrgsStat.includes('002')) || false;
  const { model: zoomModel } = useLocalObservable(() => ({ model: new ImgZoomModel() }));

  // modal ref
  const imgModalRef = useRef<any>();
  const modalRef = useRef<any>();

  // set up state of Slide

  const [currentSlide, setCurrentSlide] = useState<any>(0); //current slide index
  const SlideItem = document.getElementsByClassName('slide-items'); // slide child element
  const [startX, setStartX] = useState(0); //mouse start x postion
  const [slideIsDrag, setSlideIsDrag] = useState(false); // Drag Whether
  const [slideTransactionFinish, setSlideTransactionFinish] = useState(false); // Drag Whether
  const [dragPos, setDragPos] = useState<any>(0); // Drag postion
  const TOTAL_SLIDE = (dataSlide.length - 1) * -1; //Total Slide child
  const [approximate, setApproximate] = useState<any>([]); //approximate value
  const itemWidth = SlideItem[0]?.clientWidth; // Slide child Width
  const MAX_WIDTH = itemWidth * (dataSlide.length - 1); //Slide Wrapper width
  const DRAG_SPPED = 1; //Drag Speed
  const [isImgPopupOpen, setIsImgPopupOpen] = useState(false);
  const [popupImg, setPopupImg] = useState('');
  const swiperContainerTimer = 300;

  const onMouseDown = (e: any) => {
    e.preventDefault();
    setStartX(e.clientX);
    setSlideIsDrag(true);
  };

  const onMouseLeave = e => {
    e.preventDefault();
    setSlideIsDrag(false);
    setDragPos(0);
  };

  const onMouseUp = e => {
    e.preventDefault();

    // 드래그 여부 평가
    // 1. 이전에 드래그가 이뤄진 경우
    if (zoomModel.isLastDrag()) {
      setSlideTransactionFinish(true);
      zoomModel.setSync(); // 동기화 (prev와 현재 좌표를 동일하게 맞춘다)
      setCurrentSlide(SetCurretSlide(e));
      setDragPos(0);
    }
    // 2. 드래그가 이뤄지지 않은 경우
    else {
      zoomModel.setInit(); // 초기화 (모든 좌표 0)
      zoomModel.setIsZoom(false);

      setDragPos(0);
    }

    setSlideIsDrag(false);
    setTimeout(() => {
      setSlideTransactionFinish(false);
    }, swiperContainerTimer);
  };

  const onMouseMove = e => {
    if (slideIsDrag) {
      zoomModel.setIsMousePosition(zoomModel.x + e.clientX, zoomModel.y + e.clientY);
      SetApproximateArray();
      const walk = (e.clientX - startX) * DRAG_SPPED;

      if (!walk) setDragPos(walk * -1);
      else setDragPos(walk);
    } else {
      return;
    }
  };

  const handleClickImg = (img: string) => {
    console.log(slideTransactionFinish);
    if (!slideTransactionFinish) {
      setIsImgPopupOpen(true);
      setPopupImg(img);
    }
  };

  const SetApproximateArray = () => {
    const first = (currentSlide + 1) * itemWidth <= 0 ? (currentSlide + 1) * itemWidth : 0;
    const last =
      Math.abs((currentSlide - 1) * itemWidth) <= Math.abs(MAX_WIDTH) ? (currentSlide - 1) * itemWidth : MAX_WIDTH * -1;

    setApproximate([first, currentSlide * itemWidth, last]);
  };

  const SetCurretSlide = e => {
    const target = currentSlide * itemWidth + dragPos * 2;
    let abs = 0;
    let min = approximate[2];
    let near = 0;

    for (let i = 0; i < approximate.length; i++) {
      abs = approximate[i] - target < 0 ? approximate[i] - target : -(approximate[i] - target);

      if (abs > min) {
        min = abs;
        near = approximate[i] / itemWidth;
      }
    }

    return near;
  };

  const nextSlide = e => {
    e.stopPropagation();
    setCurrentSlide(currentSlide - 1);
  };

  const prevSlide = e => {
    e.stopPropagation();
    setCurrentSlide(currentSlide + 1);
  };

  // set up state of child slide
  const [startXChild, setStartXChild] = useState<any>(0);
  const [childIsDrag, setChildIsDrag] = useState(false);
  const [childCurrentSlide, setChildCurrent] = useState<any>(0);
  const ChildItems = document.getElementsByClassName('slide-items-child');
  const [childDragPos, setChildDragPos] = useState<any>(0);
  const [childWidth, setChildWidth] = useState(0);
  const [swiperWidth, setSwiperWidth] = useState(0);
  const [moveArr, setMoveArr] = useState<any>([]);
  const margin = 40;
  const MAX_SIZE = swiperWidth - childWidth;

  const initSwiper = () => {
    const swiperWidth = document.getElementById('scrollChild')?.offsetWidth;
    const wrapWidth = document.getElementById('swiperWrap')?.offsetWidth;

    if (swiperWidth) setChildWidth(swiperWidth);
    if (wrapWidth) setSwiperWidth(wrapWidth);
  };
  const move = ChildItems[0]?.clientWidth + margin;

  const clamp = (val: number, min: number, max: number) => Math.min(Math.max(val, min), max);

  const SetChildApproximateArray = () => {
    const first = clamp(getTranstion('next'), MAX_SIZE, 0);
    const last = clamp(getTranstion('prev'), MAX_SIZE, 0);

    setMoveArr([first, childDragPos, last]);
  };
  const getTranstion = (type: string) => {
    if (type === 'next') {
      return Math.floor(((childCurrentSlide + 1) * move) / move) * move;
    } else {
      return Math.floor(((childCurrentSlide - 1) * move) / move) * move;
    }
  };
  const onChildMouseDown = (e: any) => {
    e.stopPropagation();
    setChildIsDrag(true);
    setStartXChild(e.clientX);
  };

  const onChildMouseLeave = e => {
    e.stopPropagation();
    setChildIsDrag(false);
    setChildDragPos(0);
  };

  const onChildMouseUp = e => {
    e.stopPropagation();
    setChildIsDrag(false);
    setChildDragPos(0);
    setMoveArray(e);
  };

  const setMoveArray = e => {
    const target = clamp(move * childCurrentSlide + childDragPos, MAX_SIZE, 0);

    let abs = 0;
    let min = moveArr[2];
    let near = 0;

    for (let i = 0; i < moveArr.length; i++) {
      abs = moveArr[i] - target < 0 ? moveArr[i] - target : -(moveArr[i] - target);

      if (abs > min) {
        min = abs;
        near = Math.floor(clamp(moveArr[i], MAX_SIZE, 0) / move);
      }
    }
    if (e.type !== 'mousemove') {
      setChildCurrent(near);
      setChildDragPos(0);
    }
  };

  const onThrottleDragMove = e => {
    e.stopPropagation();
    if (!childIsDrag) return;

    SetChildApproximateArray();
    setMoveArray(e);
    const walk = (e.clientX - startXChild) * DRAG_SPPED;

    if (!walk) setChildDragPos(walk * -1);
    else setChildDragPos(walk);
  };

  const nextSlideChild = e => {
    e.stopPropagation();

    if (childDragPos > swiperWidth) {
      return;
    } else {
      setChildDragPos(childDragPos - move);
    }
  };

  const prevSlideChild = e => {
    e.stopPropagation();

    if (clamp(currentSlide * move, MAX_SIZE, 0) + childDragPos > 0) {
      return;
    } else {
      setChildDragPos(childDragPos + move);
    }
  };

  const moveDot = (e, index) => {
    e.stopPropagation();
    setCurrentSlide(index * -1);
  };

  //   state switch
  const [isSwitch, setIsSwitch] = useState(false);
  const handleSwitch = () => {
    setIsSwitch(!isSwitch);
  };

  //SET STATE FOR SIDEBAR FIXED
  useEffect(() => {
    initSwiper();
  }, []);

  // 사이드바 소메뉴입니다.
  const sidebarList = [
    { name: '단지정보', isActive: true },
    { name: '세대정보', isActive: true },
    { name: '프리미엄', isActive: true },
    { name: '분양 일정', isActive: true},
    { name: '새소식', isActive: false},
  ];

  // 사이드바 소메뉴에 정보를 바탕으로 우측 사이드 네비게이션을 구성합니다.
  // const filterSideBarList = () => {
  //   if (isScheduledForSale) {
  //     return sidebarList.filter(item => item.display === 'show');
  //   } else {
  //     return sidebarList;
  //   }
  // };

  const salesInfo = toJS(mainModel.mainData.data);
  const newsSection = toJS(mainModel.mainData.data);

  return (
    <div className="contents-general-outline">
      <div className="content">
        {/* 우측 사이드 네비게이션을 표출합니다. */}
        <SidebarScroll sidebarList={sidebarList} />

        {/* 단지정보  */}
        {sidebarList[0].isActive ? (
        <Element name={sidebarList[0].name}>
          <ComplexSection salesInfo={salesInfo} />
        </Element>
        ) : null}

        {/* 세대 정보 */}
        {sidebarList[1].isActive ? (
        <Element name={sidebarList[1].name}>
          <div id="slide" className="slide">
            <div className="slide-container">
              <div className="slide-container-header">
                <div className="slide-title">
                  <a>
                    <PageMoveText link={`#${RoutesString.SalesHousehold}`}>
                      <div>세대 정보</div>
                      <div className="arrow-right"></div>
                    </PageMoveText>
                  </a>
                </div>
                <div className="slide-info">
                  <div className="slide-info-detail">
                    <span>㎡ (전용면적)</span>
                  </div>
                  <div
                    onClick={handleSwitch}
                    style={{ background: `${isSwitch ? '#ff671d' : '#eee'}` }}
                    className="slide-info-switch">
                    <span style={{ left: `${isSwitch ? '60%' : '0'}` }} className="switch-icon"></span>
                  </div>
                  <div className="slide-info-icon">
                    <span>평</span>
                    <img src={GetStyledCompImg('parcelOut/ico_question.png')} alt="" />
                    <div className="header-tooltip">
                      <p className="header-tooltip-title" style={{ paddingTop: 15 }}>
                        평 전환 기준 :{' '}
                      </p>
                      <div className="header-tooltip-detail" style={{ paddingTop: 5 }}>
                        아파트는 공급면적, 오피스텔은 계약면적
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="slider">
                <div className="swiper-container" id="test">
                  <div
                    className="swiper-wrapper no-drag"
                    onMouseLeave={onMouseLeave}
                    onMouseDown={onMouseDown}
                    onMouseUp={onMouseUp}
                    onMouseMove={onMouseMove}
                    style={{
                      transitionDuration: `${slideIsDrag ? '0' : `${swiperContainerTimer}`}ms`,
                      transform: `translate3d(${currentSlide * SlideItem[0]?.clientWidth + dragPos}px,0,0)`
                    }}>
                    {dataSlide.map((sp, index) => {
                      return (
                        <div
                          // onDragStart={onDrag}

                          key={index}
                          className={`slide-items`}>
                          <div className="slide-items-img">
                            <img
                              src={sp.img}
                              alt=""
                              draggable="false"
                            />
                          </div>
                          <div className="slide-items-content">
                            <div className="content-title">
                              {isSwitch ? (
                                <div className="title" draggable="false">
                                  {sp.titleSwitchActive}
                                </div>
                              ) : (
                                <div className="title" draggable="false">
                                  {sp.title}
                                </div>
                              )}
                              <div className="subTitle" draggable="false">
                                {/* 총 {sp.total}실
                                <small>우선공급 {sp.subTitle}실, 일반분양 {sp.subTitle02}실</small> */}
                                <small>{sp.subTitle}</small>
                              </div>
                            </div>
                            <div className="content-detail">
                              <span>{sp.detail}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <button
                    onClick={currentSlide <= TOTAL_SLIDE ? undefined : nextSlide}
                    className={currentSlide <= TOTAL_SLIDE ? 'swiper-button-next endSlide' : 'swiper-button-next'}></button>
                  <button
                    onClick={currentSlide === 0 ? undefined : prevSlide}
                    className={currentSlide === 0 ? 'swiper-button-prev endSlide' : 'swiper-button-prev'}></button>
                </div>
                <div className="swiper-child-contaier">
                  <div className="swiper-child" id="swiperWrap">
                    <div
                      id="scrollChild"
                      className="swiper-child-wrap no-drag "
                      onMouseDown={onChildMouseDown}
                      onMouseMove={onThrottleDragMove}
                      onMouseUp={onChildMouseUp}
                      onMouseLeave={onChildMouseLeave}
                      style={{
                        transitionDuration: `${childIsDrag ? 0 : 300}ms`,
                        transform: `translate3d( ${clamp(currentSlide * move, MAX_SIZE, 0) + childDragPos}px, 0px, 0px)`
                      }}>
                      {dataSlide.map((sp, index) => {
                        return (
                          <div
                            onClick={e => moveDot(e, index)}
                            key={index}
                            style={{
                              marginRight: `${dataSlide.length - 1 === index ? 0 : margin}px`
                            }}
                            className="slide-items-child">
                            <span className={currentSlide === index * -1 ? 'dotActive' : ''}>
                              {isSwitch ? `${sp.titleSwitchActive}` : `${sp.title}`}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <button
                    onClick={prevSlideChild}
                    className={
                      clamp(currentSlide * move, MAX_SIZE, 0) + childDragPos >= 0
                        ? 'swiper-button-prev-child child-button-hidden'
                        : 'swiper-button-prev-child'
                    }></button>
                  <button
                    onClick={currentSlide * move + childDragPos <= MAX_SIZE ? undefined : nextSlideChild}
                    className={
                      currentSlide * move + childDragPos <= MAX_SIZE
                        ? 'swiper-button-next-child child-button-hidden'
                        : 'swiper-button-next-child'
                    }></button>
                </div>
              </div>
              <div className="slide-table">
                <table className="table-col">
                  <colgroup>
                    <col style={{ width: '50%' }} />
                    <col style={{ width: '50%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th className="border-b">분양 타입(㎡)</th>
                      <th className="border-b">세대 수</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataSlide.map((sp, index) => {
                      return (
                        <tr key={index}>
                          <td className="border-b">{isSwitch ? sp.titleSwitchActive : sp.title}</td>
                          <td>{sp.total}</td>
                          {/* <td>{sp.subTitle02}</td>
                          <td>{sp.total}</td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr className="bg-grey" data-type-result="data-type-result">
                      <td className="border-b">{dataSlideResult.title}</td>
                      <td className="border-b">{dataSlideResult.subTitle}</td>
                      {/* <td className="border-b">{dataSlideResult.subTitle02}</td>
                      <td className="border-b">{dataSlideResult.total}</td> */}
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </Element>
        ) : null}

        {/* 프리미엄 섹션 */}
        {sidebarList[2].isActive ? (
        <Element name={sidebarList[2].name}>
          <PremiumSection />
        </Element>
        ) : null}

        {/* 분양 일정 섹션  */}
        {sidebarList[3].isActive ? (
        <Element name={sidebarList[3].name}>
          <CalenderSection />
        </Element>
        ) : null}

        {/* 새소식  */}
        {sidebarList[4].isActive ? (
        <Element name={sidebarList[4].name}>
          <div id='news' className='news'>
            <div className='news-container'>
              <div className='news-title'>
                <PageMoveText link={`#${RoutesString.SalesNews}`}>
                  <div className='news-title-txt'>새소식</div>
                  <div className="arrow-right"></div>
                </PageMoveText>
              </div>
  
              <NewsSection newsSection={newsSection} />
            </div>
          </div>

        </Element>
        ) : null}
      </div>

      <ImgPopup img={popupImg} open={isImgPopupOpen} setOpen={setIsImgPopupOpen} />
    </div>
  );
});

export default GeneralOutline;
